import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import Cookies from 'universal-cookie';

import getPresentationEditEndpoints from './presentationEdit';

const cookies = new Cookies();

export const mainApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: '/api',
    prepareHeaders: headers => {
      const token = cookies.get('CLIENT_TOKEN');

      if (token) {
        headers.set('Authorization', token);
      }
      return headers;
    },
  }),
  tagTypes: ['RenderData'],
  refetchOnMountOrArgChange: true,
  endpoints: build => {
    return {
      ...getPresentationEditEndpoints(build),
    };
  },
});

export const {
  // presentationEdit hooks
  useGetRenderDataQuery,
} = mainApi;
